<template>
  <section>
    <BaseAccordion
      v-for="(requisite,index) in value"
      :key="index"
      class="bg-gray-200 rounded"
    >
      <div class="p-2">{{ requisite.name || 'Untitled Requisite' }}</div>
      <template #content>
        <section class="px-4 py-2 bg-white border-l border-r border-b rounded">
          <RequisiteAdvance
            :level="1"
            :value="requisite"
          />
        </section>
      </template>
    </BaseAccordion>
  </section>
</template>

<script>
import RequisiteAdvance from './RequisiteAdvance'

export default {
  components: {
    RequisiteAdvance,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
